import { Select } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../components/elements/Card';
import DataTable from '../../components/elements/DataTable';
import Text from '../../components/fields/Text';
import styles from './styles.scoped.css';

import { useParams } from 'react-router-dom';
import { fetchAgenHistory } from './actions';

import { AppContext, ToastrContext } from '../../contexts';
import { useDebounce } from '../../utils/hooks';

function AgenHistory() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [search, setSearch] = useState('');
  const [page] = useState(1);
  const [size, setSize] = useState(10);
  const { setToastr } = useContext(ToastrContext);
  const debounceSearch = useDebounce(search, 500);
  const { setBreadcrumbs } = useContext(AppContext);

  const {
    agenHistory: { data, loading, message, success },
    detail
  } = useSelector((s) => s.merchantSetting);

  useEffect(() => {
    setBreadcrumbs([
      { name: 'Data Pangkalan LPG 3 Kg', to: '/merchant/setting-data-merchant/' },
      { name: detail?.data?.ownerName, to: `/merchant/setting-data-merchant/detail/${id}` },
      'Riwayat Pergantian Agen']);
    dispatch(fetchAgenHistory(id, { page, size }));
  },[]);

  useEffect(() => {
    dispatch(fetchAgenHistory(id, { page, size, search: debounceSearch }));
  },[debounceSearch, size]);

  useEffect(() => {
    if(!loading && !success && message){
      setToastr({
        visible: true,
        desc: message,
        type: 'danger',
      });
    }
  },[message, success, loading]);

  const column = [
    {
      heading: 'Agen Pengganti',
      value: ({ selectedAgenName, soldTo }) => `${soldTo} - ${selectedAgenName}`,
      className: '',
    },
    {
      heading: 'Tanggal Update',
      value: 'createdAt',
      className: '',
    },
  ];

  return (
    <main className={styles.root}>
      <Card className={styles['table-filter-container']} >
        <div className={styles.pageSize}>
          <Select
            data={['10', '25', '50', '75', '100']}
            defaultValue={'10'}
            onChange={(e) => setSize(e)}
          />
          <span>baris</span>
        </div>
        <Text
          className={styles['search-bar']}
          hideLabel
          inputProps={{
            placeholder: 'Cari data...',
            value: search,
            icon: 'ic-search.svg',
            onChange: (e) =>  setSearch(e.target.value),
          }}
        />
      </Card>
      <DataTable
        className={styles.table}
        column={column}
        data={data}
        loading={loading}
        withIndex
      />
    </main>
  );
}

export default AgenHistory;
